<div class="titolo" [innerHtml]="titolo"></div>
<div class="descrizione" [innerHtml]="descrizione"></div>
